import { useState } from "react";
import {
  getProducts,
  getProductById,
  createProduct,
  updateProduct,
  deleteProduct,
} from "api/product.api";

export function useProducts() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadProducts = async (company_id) => {
    setLoading(true);
    try {
      const res = await getProducts(company_id);
      setData(res.data || []);
      return res.data;
    } finally {
      setLoading(false);
    }
  };

  const loadProductById = async (id) => {
    const res = await getProductById(id);
    return res.data;
  };

  const addProduct = async (payload) => {
    const res = await createProduct(payload);
    return res.data;
  };

  const editProduct = async (id, payload) => {
    const res = await updateProduct(id, payload);
    return res.data;
  };

  const removeProduct = async (id, payload) => {
    const res = await deleteProduct(id, payload);
    return res.data;
  };

  return {
    data,
    loading,
    loadProducts,
    loadProductById,
    addProduct,
    editProduct,
    removeProduct,
  };
}
